import { Component } from 'react'
import { AlertOctagon, RefreshCw } from 'lucide-react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined' && typeof window.__reportFatal === 'function') {
      window.__reportFatal(error?.message || String(error), info?.componentStack || error?.stack || '')
    } else {
      console.error('App error:', error, info)
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex h-screen items-center justify-center bg-slate-50 p-6">
          <div className="w-full max-w-lg rounded-xl border border-rose-200 bg-white p-5 shadow-soft">
            <div className="flex items-center gap-2 text-rose-700">
              <AlertOctagon className="h-5 w-5" />
              <h2 className="text-sm font-semibold">Something went wrong.</h2>
            </div>
            <p className="mt-2 text-xs text-slate-600">
              The workbench hit an unexpected error. You can reload to start over —
              your files were never uploaded anywhere.
            </p>
            <pre className="mt-3 max-h-48 overflow-auto rounded-md bg-rose-50 p-3 text-[11px] text-rose-900">
              {this.state.error?.message || String(this.state.error)}
            </pre>
            <button
              onClick={() => location.reload()}
              className="btn-primary mt-4 h-9 px-3 text-xs"
            >
              <RefreshCw className="h-3.5 w-3.5" />
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
